import without from 'lodash/without';
import pick from 'lodash/pick';
import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import AppointmentReport from '../reports/appointmentReport';
import {
  getAppointmentsReport,
  getAppointmentsReportCsv,
} from '../reports/actions';
import {
  getPaymentFilters,
  getAppointmentStatusFilters,
  getAppointmentPlatformFilters,
  getAppointmentBookedByFilters,
  getSelectedFilterSlugs,
  getSelectedFilterNames,
  getSelectedBarberFilterIds,
} from '../reports/selectors';
import withTimezone from '../../auth/utils/withTimezone';
import {
  activeShopName,
  activeShopPaymentDepositsEnabled
} from '../../auth/selectors';

const mapStateToProps = state => ({
  shop: state.auth.shop,
  shopName: activeShopName(state),
  startDate: state.reports.startDate,
  endDate: state.reports.endDate,
  barberIds: without(getSelectedBarberFilterIds(state), 'unassigned'),
  payments: getSelectedFilterSlugs(getPaymentFilters(state)),
  status: getSelectedFilterSlugs(getAppointmentStatusFilters(state)),
  platform: getSelectedFilterNames(getAppointmentPlatformFilters(state)),
  bookedBy: getSelectedFilterSlugs(getAppointmentBookedByFilters(state)),
  showDepositsSecured: activeShopPaymentDepositsEnabled(state),
});

const mapDispatchToProps = {
  getAppointmentsReport,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTimezone,
  withHandlers({
    getReport: props => () => props.getAppointmentsReport(
      props.shop,
      'shop',
      pick(props, ['payments', 'status', 'platform', 'bookedBy', 'barberIds', 'startDate', 'endDate']),
      props.timezone
    ),
    getCsv: props => () => getAppointmentsReportCsv(
      props.shop,
      'shop',
      props.shopName,
      pick(props, ['payments', 'status', 'platform', 'bookedBy', 'barberIds', 'startDate', 'endDate']),
      props.timezone
    ),
  }),
);

export default enhance(AppointmentReport);
